import { render, staticRenderFns } from "./SenatorialZoneList.vue?vue&type=template&id=6ff6ed7e&"
import script from "./SenatorialZoneList.vue?vue&type=script&lang=js&"
export * from "./SenatorialZoneList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports